module.exports = __webpack_public_path__ + "static/media/Artboard_mobile.db8c9426.png";